<p-dialog
  styleClass="widget-dialog"
  header="Add widget"
  i18n-header="@@widget_creation.page.header.title"
  [modal]="true"
  [(visible)]="visible"
  closeOnEscape="true"
  draggable="false"
  dismissableMask="true"
  resizable="false"
  (onHide)="close()">

  <form class="form" [formGroup]="widgetCreationForm">

    <p-stepper [(value)]="currentStep" (valueChange)="onStepChange($event)">
      <p-step-list>
        <p-step [value]="1" i18n="@@widget_creation.step.type.title">Widget type</p-step>
        <p-step
          [value]="2"
          [disabled]="!widgetCreationForm.valid"
          i18n="@@widget_creation.step.configuration.title">
          Configuration
        </p-step>
      </p-step-list>

      <p-step-panels>

        <p-step-panel [value]="1">
          <ng-template #content>
            <h3 i18n="@@widget_creation.step.base.subtitle">Customize your homepage</h3>

            <p i18n="@@widget_creation.step.base.intro">
              Use this form to configure a widget that will appear on your homepage dashboard. Once
              added, your widget will personalize your dashboard and make relevant information
              easier to access.
            </p>

            <div class="form__field">
              <label for="widgetType" class="input__label" i18n="@@widget_creation.field.type.label">
                Type
              </label>

              <p-select
                id="widgetType"
                formControlName="widgetType"
                [options]="widgetTypes"
                appendTo="body"
                optionLabel="label"
                optionValue="value"
                placeholder="Select a type"
                i18n-placeholder="@@widget_creation.field.type.placeholder">
              </p-select>

              @if (
                widgetCreationForm.get('widgetType')?.invalid &&
                widgetCreationForm.get('widgetType')?.dirty
              ) {
                <small class="input__error" i18n="@@widget_creation.field.type.error.required"
                  >Type is required</small
                >
              } @else if (!canAddWidget) {
                <small class="input__error" i18n="@@widget_creation.field.type.error.cannot_add">
                  This widget cannot be placed on the dashboard. Please select a different type or resize/remove other widgets.
                </small>
              }
            </div>

            <div class="stepper__actions">
              <p-button
                label="Next"
                i18n-label="@@common.button.next"
                icon="pi pi-arrow-right"
                iconPos="right"
                (onClick)="nextStep()"
                [disabled]="widgetCreationForm.invalid || !canAddWidget" />
            </div>
          </ng-template>
        </p-step-panel>

        <p-step-panel [value]="2">
          <ng-template #content>
            <h3 class="stepper__header" i18n="@@widget_creation.step.configuration.subtitle">
              Widget settings
              @if(guideLink) {
                <a [href]="guideLink" target="_blank">
                  <p-button
                    icon="pi pi-question-circle"
                    iconPos="right"
                    [rounded]="true"
                    [text]="true"
                    size="small"
                    />
                </a>
              }
            </h3>

            <p i18n="@@widget_creation.step.configuration.description">
              Customize how your
              <b
                ><i>{{ selectedWidgetLabel }}</i></b
              >
              widget. It will appear and behave on your homepage.
            </p>

            <ng-container #configContainer></ng-container>

            <div class="stepper__actions">
              <p-button
                class="stepper__action--start"
                label="Back"
                i18n-label="@@common.button.back"
                severity="secondary"
                icon="pi pi-arrow-left"
                (onClick)="prevStep()" />
              <p-button
                label="Add widget"
                i18n-label="@@widget_creation.button.add_widget"
                (onClick)="saveConfiguration()"
                [disabled]="!isConfigurationValid()" />
            </div>
          </ng-template>
        </p-step-panel>
      </p-step-panels>
    </p-stepper>
  </form>
</p-dialog>
